var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comDetail"},[(_vm.ComName.length > 0)?_c('ForeignInfo',{attrs:{"comid":_vm.ComId,"comname":_vm.ComName}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }